import { render, staticRenderFns } from "./commonPieChart.vue?vue&type=template&id=b80411a0&scoped=true"
import script from "./commonPieChart.vue?vue&type=script&lang=js"
export * from "./commonPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80411a0",
  null
  
)

export default component.exports